import { useEffect, useRef } from 'react';

/**
 * Hook pour détecter les clics en dehors d'un élément
 * @param {Function} handler - Fonction à exécuter lors du clic en dehors
 * @returns {Object} - Ref à attacher à l'élément
 */
export const useClickOutside = (handler) => {
  const ref = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handler]);

  return ref;
};
